const transaltions = {
  // Invia un messaggio - placeholder chat
  'sendAMessage-it': 'Invia un messaggio',
  'sendAMessage-en': 'Send a message',

  // Invia - testo bottone
  'send-it': 'Invia',
  'send-en': 'Send',

  //<< MODULO CONTATTO CHAT >>
  // Nome
  'contactName-it': 'Nome',
  'contactName-en': 'Name',

  // Email
  'contactEmail-it': 'Email',
  'contactEmail-en': 'Email',

  // Azienda
  'contactCompany-it': 'Azienda',
  'contactCompany-en': 'Company',

  // Professione
  'contactJob-it': 'Professione',
  'contactJob-en': 'Job',

  // Telefono
  'contactPhone-it': 'Numero di Telefono',
  'contactPhone-en': 'Phone',
};

export default transaltions;
